import '@awesome.me/webawesome/dist/components/divider/divider.js';
import '@awesome.me/webawesome/dist/components/option/option.js';
import '@awesome.me/webawesome/dist/components/select/select.js';

/** Marker export for tests and tooling; importing this module performs registration. */
export const selectElementsRegistered = true;
